import React from 'react'
import CountdownClock from '../../components/CountdownClock/CountdownClock';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import device from '../../theme/MediaQueries';


const StyledSection = styled.section`
  
  overflow-x: visible;

  + section .section-inner {
    padding-top: 0;
  }

  & .intro-card {
    width: 80%; 
    margin: 0 auto;

    @media ${device.MXmd} {
      width: 100%;
    }
  }PRAWN-38

`

const CardWrap = styled(Link)`
  flex: 0 0 50%;
  padding: 1%;
  width: 100%;
  
  @media ${device.MXmd} {
    flex: 0 0 100%;
    width: 100%;
  }

  & .card {
    position: relative;
    padding-top: calc(var(--space-l) * 1.1);
  }

  & .centered {
    height: 100%;
    align-items: center;
    display: flex;
  }

  & .logoWrap {
    margin-top: 4px;
  }
  
`

const CountdownWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  padding-top: 0 !important;
`

export default function CountdownSection({countdownData, isHome}) {
  return (
    <StyledSection className='page-width'>
      {isHome && <h2 className=" text--center">Key Ecosytem Countdowns</h2>}
      <CountdownWrapper className="section-inner">
        { countdownData.map((timer) => {
          return (
            <CardWrap to={timer.cardLink} key={timer.id} className="card-wrap">    
              <div className="card primary centered larger-content">    
                <CountdownClock countdownContent={timer}/>
              </div>
            </CardWrap>
        )})}
      </CountdownWrapper>
    </StyledSection> 
  )
}
